/* tslint:disable */
type PlanAction =
  'ADOPTION' |
  'TERMINATION' |
  'AMENDMENT';
module PlanAction {
  export const ADOPTION: PlanAction = 'ADOPTION';
  export const TERMINATION: PlanAction = 'TERMINATION';
  export const AMENDMENT: PlanAction = 'AMENDMENT';
  export function values(): PlanAction[] {
    return [
      ADOPTION,
      TERMINATION,
      AMENDMENT
    ];
  }
}

export { PlanAction }